export enum IdentificationTypeEnum {
    Cedula = "Cedula", 
    Dni = "Dni", 
    Cuit = 'Cuit', 
    Ruc = 'Ruc',
    Pasaporte = 'Pasaporte',
    Otro = 'Otro',
    ConsumidorFinal = 'Consumidor Final'
}
